import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppolowUcfirstPipe } from '@appolow/form';
import { TranslocoPipe } from '@jsverse/transloco';
import { ConfirmDialogComponent } from '@shared/components/confirm-dialog/confirm-dialog.component';
import { of } from 'rxjs';
import { DialogService } from '@core/services/dialog.service';

@NgModule({
	imports: [TranslocoPipe, AppolowUcfirstPipe, ConfirmDialogComponent],
	exports: [ConfirmDialogComponent],
	providers: [
		{
			provide: APP_INITIALIZER,
			useFactory: () => () => of(),
			deps: [DialogService],
			multi: true
		}
	]
})
export class DialogModule {}
